import CompletedIcon from "../../../../../assets/svg/completed-icon";
import CrossIcon from "../../../../../assets/svg/cross-icon";
import DraftIcon from "../../../../../assets/svg/draft-icon";
import RefreshIcon from "../../../../../assets/svg/refresh-icon";
import RunningIcon from "../../../../../assets/svg/running-icon";
import ScheduledIcon from "../../../../../assets/svg/scheduled-icon";
import TerminatedIcon from "../../../../../assets/svg/terminated-icon";

export const getStatusColor = (status: string) => {
  switch (status) {
    case "running":
      return "text-verba-blue dark:text-verba-blue-dk text-md font-medium";
    case "scheduled":
      return "text-analytics-safety dark:text-analytics-safety-dk text-md font-medium";
    case "completed":
      return "text-verba-green-success dark:text-verba-green-success-dk text-md font-medium";
    case "draft":
      return "text-gray-placeholder dark:text-gray-placeholder-dk text-md font-medium";
    case "failed":
      return "text-verba-red-alert dark:text-verba-red-alert-dk text-md font-medium";
    case "terminated":
      return "text-verba-red-alert dark:text-verba-red-alert-dk text-md font-medium";
    case "retry_in_progress":
      return "text-retrying-status dark:text-retrying-status-dk text-md font-medium";
    default:
      return "text-heading-text dark:text-heading-text-dk text-md font-medium";
  }
};

export const getStatusIcon = (status: string) => {
  switch (status) {
    case "running":
      return (
        <RunningIcon
          className={`w-[14px] h-[14px] ${getStatusColor(status)}`}
        />
      );
    case "scheduled":
      return (
        <ScheduledIcon
          className={`w-[14px] h-[14px] ${getStatusColor(status)}`}
        />
      );
    case "completed":
      return (
        <CompletedIcon
          className={`w-[14px] h-[14px] ${getStatusColor(status)}`}
        />
      );
    case "draft":
      return (
        <DraftIcon className={`w-[14px] h-[14px] ${getStatusColor(status)}`} />
      );
    case "failed":
      return (
        <CrossIcon className={`w-[14px] h-[14px] ${getStatusColor(status)}`} />
      );
    case "terminated":
      return (
        <TerminatedIcon
          className={`w-[14px] h-[14px] ${getStatusColor(status)}`}
        />
      );
    case "retry_in_progress":
      return (
        <RefreshIcon
          className={`w-[14px] h-[14px] ${getStatusColor(status)}`}
        />
      );
    default:
      return null;
  }
};

export const getSortDirection = (direction: string | false | undefined) => {
  if (!direction) return undefined;
  return direction === "asc" ? "ascending" : "descending";
};

export const getProgressColors = (status: string) => {
  switch (status) {
    case "running":
      return {
        trackColor: "bg-gray-75 dark:bg-gray-75-dk",
        fillColor: "bg-verba-blue-dark-mode dark:bg-verba-blue-dark-mode-dk",
      };
    case "scheduled":
      return {
        trackColor: "bg-gray-75 dark:bg-gray-75-dk",
        fillColor: "bg-analytics-safety dark:bg-analytics-safety-dk",
      };
    case "completed":
      return {
        trackColor: "bg-gray-75 dark:bg-gray-75-dk",
        fillColor: "bg-verba-green-success dark:bg-verba-green-success-dk",
      };
    case "draft":
      return {
        trackColor: "bg-gray-75 dark:bg-gray-75-dk",
        fillColor: "bg-gray-placeholder dark:bg-gray-placeholder-dk",
      };
    case "failed":
      return {
        trackColor: "bg-gray-75 dark:bg-gray-75-dk",
        fillColor: "bg-verba-red-alert dark:bg-verba-red-alert-dk",
      };
    case "terminated":
      return {
        trackColor: "bg-gray-75 dark:bg-gray-75-dk",
        fillColor: "bg-verba-red-alert dark:bg-verba-red-alert-dk",
      };
    case "retry_in_progress":
      return {
        trackColor: "bg-gray-75 dark:bg-gray-75-dk",
        fillColor: "bg-retrying-status dark:bg-retrying-status-dk",
      };
    default:
      return {
        trackColor: "bg-gray-75 dark:bg-gray-75-dk",
        fillColor: "bg-verba-indigo dark:bg-verba-indigo-dk",
      };
  }
};
